<script>
export default {
    name: 'IconLess',
}
</script>
<template>
    <svg class="base-icon icon-less" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M64 27v10H0V27h64Z" clip-rule="evenodd"/></svg>
</template>
